/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  EventType,
  InitMessage,
  OfferReadyMessage,
  OfferStateChangeMessage,
  ReadyMessage,
  ResizeMessage,
  TokenizePaymentMessage,
  UpdateMessage,
  ValidateMessage
} from "./types";

export const isInitMessage = (value: any): value is InitMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.init;
}

export const isValidateMessage = (value: any): value is ValidateMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.validate;
}

export const isReadyMessage = (value: any): value is ReadyMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.ready;
}

export const isResizeMessage = (value: any): value is ResizeMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.resize;
}

export const isOfferStateChangeMessage = (value: any): value is OfferStateChangeMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.offer_state_change;
}

export const isOfferReadyMessage = (value: any): value is OfferReadyMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.offer_state_ready;
}

export const isTokenizePaymentMessage = (value: any): value is TokenizePaymentMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.tokenize_payment;
}

export const isUpdateMessage = (value: any): value is UpdateMessage => {
  return typeof value === "object" && 'eventType' in value && value.eventType === EventType.update;
}


/**
 * We don't need a cryptographically secure UUID for this use case, so we can use a simple implementation.
 * @returns A random UUIDv4 string.
 */
export const uuidv4 = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}